module.exports = __webpack_public_path__ + "static/media/benefit_logo.5ed86fcb.svg";